import React from 'react';
import { Line as KonvaLine } from 'react-konva';

export const DashedLine: React.FC<{
    points: number[];
    dash?: number[];
    strokeWidth?: number;
    stroke?: string;
}> = React.memo(
    ({
         points,
         dash = [8, 5],
         strokeWidth = 1,
         stroke = 'black',
     }) => (
        <KonvaLine
            points={points}
            stroke={stroke}
            strokeWidth={strokeWidth}
            dash={dash}
        />
    ),
);